import Report, { ReportFormProps } from 'common/pages/report/Container.tsx'

const ReportFormAdmin = (props: ReportFormProps) => {
  return <Report {...props} allowCreateRetargetingList={false} />
}

export { ReportFormAdmin }
